import { ActionFunction } from '../interface/action/action-function.type';
import { ActionEnum } from '../enum/action.enum';
import { IMessage } from '../interface/message.interface';
import { action } from 'mobx';

export const addGlobalError$: ActionFunction<IMessage> = (action$, {state}) => {
  return action$
    .type(ActionEnum.ADD_GLOBAL_ERROR)
    .end(action((error: IMessage) => {
      state.messages.unshift({
        id: error.id,
        appearance: 'error',
        title: error.title,
        message: error.message
      });
    }));
};

export default {
  actions: [ addGlobalError$ ]
};
